import React from 'react';
import { TEMPTED_DOMAIN } from '../../constants/apiUrls/apiUrls';
import { buildAnchorLink } from '../../utils/helpers';

import { hasRichTextMetadata } from './hasRichTextMetaData';

const isNakedNewsAnchor = (id, nickname, allAnchors) => {
  const isCurrentAnchor = allAnchors?.currentAnchors?.find((anchor) => anchor?.id === id);
  const isGuestAnchor = allAnchors?.guestAnchors?.find((anchor) => anchor?.id === id);
  const anchorData = isCurrentAnchor || isGuestAnchor;
  if (anchorData) {
    return buildAnchorLink(anchorData, '?filter=fanzone');
  }

  return `${TEMPTED_DOMAIN}/${nickname}`;
};

const replaceTextWithElement = function (txt, index, replacementLength, replacementEl) {
  if (Array.isArray(txt)) {
    const textWithoutLastElement = txt.slice(0, txt.length - 1);
    const flattenedTextArray = txt.flat(Infinity);
    let delta = 0;
    delta = flattenedTextArray.reduce((accumulatedValue, currValue, i) => {
      if (i === flattenedTextArray.length - 1) {
        return accumulatedValue;
      }
      if (typeof currValue === 'string') {
        return accumulatedValue + currValue.length;
      } else if (typeof currValue === 'object') {
        return accumulatedValue + currValue.props.children.length;
      }

      return accumulatedValue;
    })
    const indexWithoutDelta = index - delta;
    const textLastElement = txt[txt.length - 1];

    return [...textWithoutLastElement, textLastElement.substr(0, indexWithoutDelta), replacementEl, textLastElement.substr(indexWithoutDelta + replacementLength)];
  }

  return [txt.substr(0, index), replacementEl, txt.substr(index + replacementLength)];
};

const handleElementClick = (e, performerUrl) => {
  e.stopPropagation();
  e.preventDefault();
  window.open(`${performerUrl}`, '_blank,noopener,noreferrer');
}

const getReplacementElement = (isRedirectDisabled, metadata, performerUrl, entity) => {
  const nick = metadata.entityMap[entity.key].data.mention.nickname;
  if (isRedirectDisabled) {
    return (
      <span style={{ textDecoration: 'underline' }} >
        {metadata.entityMap[entity.key].data.mention.name}
      </span>
    )
  }

  return (
    <a
      className='mention-url'
      href={performerUrl}
      rel='noopener noreferrer'
      target='_blank'
      key={nick + entity.key}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => handleElementClick(e, performerUrl)}
    >
      {metadata.entityMap[entity.key].data.mention.name}
    </a>
  );
}

const addTextToTextArray = (metadata, redirectDisabled, allAnchors) => {
  const textArray = [];
  for (let i = 0; i < metadata.blocks.length; i++) {
    if (i + 1 === metadata.blocks.length) {
      textArray.push(`${metadata.blocks[i].text}`);
    } else {
      textArray.push(`${metadata.blocks[i].text}`);
    }
    metadata.blocks[i].entityRanges.forEach((entity) => {
      const nick = metadata.entityMap[entity.key].data.mention.nickname;
      const { id } = metadata.entityMap[entity.key].data.mention;
      const performerUrl = isNakedNewsAnchor(id, nick, allAnchors);
      const lastElement = textArray[textArray.length - 1];
      const replacementEl = getReplacementElement(redirectDisabled, metadata, performerUrl, entity);
      const emojiRegex = /\p{Extended_Pictographic}/ugi;
      const hasEmojisInText = emojiRegex.test(metadata.blocks[i].text);
      if (hasEmojisInText) {
        const emojiArray = [];
        emojiRegex.lastIndex = 0;
        const emojis = [...metadata.blocks[i].text.matchAll(emojiRegex)];
        for (let i2 = 0; i2 < emojis.length; i2++) {
          emojiArray[i2] = {
            value: emojis[i2][0],
            index: emojis[i2].index,
          };
        }
        for (let i2 = 0; i2 < emojiArray.length; i2++) {
          if (emojiArray[i2].index < entity.offset) {
            entity.offset += emojiArray[i2].value.length - 1;
          } else {
            break;
          }
        }
      }
      textArray[textArray.length - 1] = replaceTextWithElement(lastElement, entity.offset, entity.length, replacementEl);
    });
  }

  return textArray;
}

export const parsedMetaObject = (text, metadata, redirectDisabled, allAnchors) => {
  if (!hasRichTextMetadata(metadata)) {
    return text;
  };

  const textArray = addTextToTextArray(metadata, redirectDisabled, allAnchors) || [];

  return textArray.flat(Infinity);
};
